import React from 'react'

import { Disclosure } from '@cred/react-disclosures-sdk'

const disclaimers = (slug, vertical) => {
  const hysDisclaimers = {
    high_yield_savings: {
      wealthfront: (
        <Disclosure
          required={false}
          slug="partners-widgets.multi-vertical.rates-table.hys.wealthfront"
        />
      ),
      nationwide: (
        <Disclosure
          required={false}
          slug="partners-widgets.multi-vertical.rates-table.hys.nationwide"
        />
      ),
      discover: (
        <Disclosure
          required={false}
          slug="partners-widgets.multi-vertical.rates-table.hys.discover"
        />
      ),
      citi: (
        <Disclosure required={false} slug="partners-widgets.multi-vertical.rates-table.hys.citi" />
      ),
    },
    interest_checking: {
      axosdirect: (
        <Disclosure
          required={false}
          slug="partners-widgets.multi-vertical.rates-table.interest-checking.axosdirect"
        />
      ),
    },
  }

  return hysDisclaimers[vertical][slug]
}

export { disclaimers }
export default disclaimers
